module.exports = __webpack_public_path__ + "static/Inken-75b6a13ada143e015e6d86cedb134e31.png";